import focusableSelectors from '../helpers/focusable-selectors';
import KEYCODE from '../helpers/keycodes';

let capturedElements = [];
let tabLists = [];

class TabList {
    constructor(element, settings) {
        this.tablist = element;
        this.tabs = [...element.querySelectorAll("a")];
        this.selectCallback = settings.selectCallback || null;

        this.init();
    }

    init = () => {
        this.getTabPanels();
        this.setInitialState();

        this.tabs.forEach(tab => tab.addEventListener('click', this.clickHandler));
        this.tabs.forEach(tab =>  tab.addEventListener('keydown', this.keydownHandler));
    }


    setSelectedTab = (element) => {
        this.tabs.forEach(tab => {
            const tabHref = tab.getAttribute('href');
            const tabPanel = this.tabPanels.filter(tabPanel => `#${tabPanel.id}` === tabHref)[0];

            if (element === tab) {
                tab.removeAttribute('tabindex');
                tab.setAttribute('aria-selected', 'true');

                this.setTabIndicatorVariables(tab);

                if (typeof this.selectCallback === 'function') {
                    this.selectCallback(tab, tabPanel);
                }
            } else {
                tab.setAttribute('tabindex', '-1');
                tab.setAttribute('aria-selected', 'false');

                tabPanel.removeAttribute('data-state');
            }
        })

    }

    setTabPanelIndexes = () => {
        this.tabPanels.forEach(tabPanel => {
            const focusableElements = tabPanel.querySelectorAll(focusableSelectors.join(', ')).length;

            focusableElements
                ? tabPanel.setAttribute('tabindex', '-1')
                : tabPanel.setAttribute('tabindex', '0');
        })
    }

    getTabPanels = () => {
        this.tabPanels = this.tabs.map(tab => document.querySelector(tab.getAttribute('href')));
    }

    clickHandler = (e) => {
        this.setSelectedTab(e.target);
    }

    keydownHandler = (e) => {
        const firstTab = this.tabs[0];
        const lastTab = this.tabs[this.tabs.length - 1];
        const currentTabIndex = this.tabs.indexOf(e.target);

        if ((e.keyCode || e.which) === KEYCODE.SPACE) {
            this.setSelectedTab(e.target);
            e.target.click();
        }
        else if ((e.keyCode || e.which) === KEYCODE.LEFT || (e.keyCode || e.which) === KEYCODE.UP) {
            if (e.target === firstTab) {
                e.preventDefault();

                lastTab.focus();
            } else {
                e.preventDefault();

                const prevTabIndex = currentTabIndex - 1;
                this.tabs[prevTabIndex].focus();
            }
        }
        else if ((e.keyCode || e.which) === KEYCODE.RIGHT || (e.keyCode || e.which) === KEYCODE.DOWN) {
            if (e.target === lastTab) {
                e.preventDefault();

                firstTab.focus();
            } else {
                e.preventDefault();

                const nextTabIndex = currentTabIndex + 1;
                this.tabs[nextTabIndex].focus();
            }
        }
    }

    activateFirstPanel = () => {
        this.tabs[0].setAttribute('tabindex', '0');
        this.tabs[0].setAttribute('aria-selected', 'true');
        this.tabPanels[0].setAttribute('data-state', 'open');

        this.setTabIndicatorVariables(this.tabs[0]);
    }

    setInitialState = () => {
        this.tabs.forEach(tab => {
            tab.setAttribute('tabindex', '-1');
            tab.setAttribute('aria-selected', 'false');
        })

       const urlPanelHash = new URL(window.location.href).hash;

       if (urlPanelHash) {
           const panelTab = this.tabs.filter(tab => tab.getAttribute('href') === urlPanelHash);

           if (panelTab.length > 0) {
                panelTab[0].setAttribute('aria-selected', 'true');
                panelTab[0].removeAttribute('tabindex');

                this.setTabIndicatorVariables(panelTab[0]);
           } else {
               this.activateFirstPanel();
            }
        } else {
            this.activateFirstPanel();
        }

        this.setTabPanelIndexes();
    }

    setTabIndicatorVariables = (tab) => {
        const tabListRect = this.tablist.getBoundingClientRect();
        const tabRect = tab.getBoundingClientRect();

        const leftDelta = tabRect.left - tabListRect.left;
        document.documentElement.style.setProperty('--nav-tab-pos-left', leftDelta + "px");
        document.documentElement.style.setProperty('--nav-tab-width', tabRect.width + "px");
    }
}

export const addTabList = (element, settings) => {
    capturedElements.push(element);
    tabLists.push(new TabList(element, settings));
};

export default init = (target = document) => {
    const targetElements = [...target.querySelectorAll('[data-tablist]')];
    const dedupedTargetElements = targetElements.filter(targetElement => !capturedElements.find(capturedElement => targetElement === capturedElement));

    if (dedupedTargetElements.length === 0) return;

    dedupedTargetElements.forEach(element => {
        addTabList(element);
    });
}